'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidCreate = function IoAndroidCreate(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 28.8l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z m29.5-17.1l-3.1 3.1-6.2-6.2 3.1-3.1c0.7-0.7 1.5-0.7 2.2 0l4 4c0.7 0.7 0.7 1.5 0 2.2z' })
        )
    );
};

exports.default = IoAndroidCreate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-create.js
// module id = 2331
// module chunks = 168707334958949